import { IonButton, IonIcon, IonToast } from "@ionic/react";
import { useState } from "react";

import React from "react";
import { Notification } from "../@types/notification";
import { useDispatch } from "react-redux";
import { addNotification } from "../store/notificationsList";
import { notificationsOutline } from "ionicons/icons";

let subscribed = false;

const NotificationSubscription: React.FC = () => {
  const dispatch = useDispatch();
  const [showToast, setShowToast] = useState(false);
  const [message, setMessage] = useState("");

  if (!subscribed) {
    io.socket.on("message", (notification: Notification) => {
      dispatch(addNotification(notification));
      setMessage(notification.text || "Nueva notificación");
      setShowToast(true);
    });
    subscribed = true;
  }
  return (
    <>
      <IonButton routerLink="/app/notificaciones">
        <IonIcon icon={notificationsOutline}></IonIcon>
      </IonButton>
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={message}
        position="top"
        duration={6000}
        color="primary"
      />
    </>
  );
};

export default NotificationSubscription;
